import { createSelector } from "reselect";

export const configManagerSelector = createSelector(
    state => state.configManager.entries,
    state => state
);

export const configsSelector = createSelector(
    state => state.configManager.entries.selectedConfigs,
    state => state
);

export const dataSelectorsSelector = createSelector(
    state => state.configManager.entries.selectedDataSelectors,
    state => state
);

export const dataNormalizersSelector = createSelector(
    state => state.configManager.entries.selectedDataNormalizers,
    state => state
);

export const blockSelectorsSelector = createSelector(
    state => state.configManager.entries.selectedBlockSelectors,
    state => state
);

export const templatesSelector = createSelector(
    state => state.configManager.entries.selectedTemplates,
    state => state
);

export const selectedWorkersDialogSelector = createSelector(
    state => state.configManager.entries.workersDialog,
    state => state
);

export const publishRequestsCountSelector = createSelector(
    state => state.configManager.entries.publishRequestsCount,
    state => state
);

export const publishRequestDialogSelector = createSelector(
    state => state.configManager.entries.publishRequestDialog,
    state => state
);
